module.exports = __webpack_public_path__ + "static/media/ic-chatbot@3x.f974c67b.png";